import { render, staticRenderFns } from "./BdSuper.vue?vue&type=template&id=f8f045b4&scoped=true&"
import script from "./BdSuper.vue?vue&type=script&lang=js&"
export * from "./BdSuper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f045b4",
  null
  
)

export default component.exports